import { store } from "@maven-rest/states";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { initializeIcons } from "@fluentui/react";
import App from "./App";
import "@maven-surface/assets/style/index.scss";

initializeIcons();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

console && console.log && console.log(`> ${process.env.REACT_APP_STAGE}`);

//import reportWebVitals from "./reportWebVitals";
//reportWebVitals();
